import { create } from "zustand";
import { postData, apiHeader } from "../helpers/ApiHelper";

export const useLegalStore = create((set, get) => ({
  legalList: [],
  legalLoaded: false,
  legalLoading: false,
  setLegalList: (list) => set({ legalList: list }),
  fetchLegalList: async () => {
    const { legalLoaded, legalLoading } = get();
    if (legalLoaded || legalLoading) return;
    try {
      set({ legalLoading: true });
      const response = await postData("legalflow/list", {}, apiHeader(false));
      if (
        String(response?.status) === "200" &&
        String(response?.data?.status) === "200"
      ) {
        const list = response.data.data.list || [];
        set({ legalList: list, legalLoaded: true });
      }
    } catch (e) {
      // silent
    } finally {
      set({ legalLoading: false });
    }
  },
}));
